import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/helpers/i18n';

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Login = () => import('@/views/Login')
const PrivacyPolicy = () => import('@/views/PrivacyPolicy')
const Page404 = () => import('@/views/Page404');
const Page500 = () => import('@/views/Page500');

// Views - Pages
const RoutesList = () => import('@/views/Routes/RoutesList')
const RouteAdd = () => import('@/views/Routes/RouteAdd')
const RouteEdit = () => import('@/views/Routes/RouteEdit')
const ReservationsList = () => import('@/views/Reservations/ReservationsList')
const ReservationAdd = () => import('@/views/Reservations/ReservationAdd')
const ReservationEdit = () => import('@/views/Reservations/ReservationEdit')
const ProductsList = () => import('@/views/Products/ProductsList')
const ProductAdd = () => import('@/views/Products/ProductAdd')
const ProductEdit = () => import('@/views/Products/ProductEdit')
const PoisList = () => import('@/views/Pois/PoisList')
const PoiAdd = () => import('@/views/Pois/PoiAdd')
const PoiEdit = () => import('@/views/Pois/PoiEdit')
const PagesList = () => import('@/views/Pages/PagesList')
const PageAdd = () => import('@/views/Pages/PageAdd')
const PageEdit = () => import('@/views/Pages/PageEdit')
const OrdersList = () => import('@/views/Orders/OrdersList')
const NewsList = () => import('@/views/News/NewsList')
const NewsAdd = () => import('@/views/News/NewsAdd')
const NewsEdit = () => import('@/views/News/NewsEdit')
const HeroList = () => import('@/views/Hero/HeroList')
const HeroAdd = () => import('@/views/Hero/HeroAdd')
const HeroEdit = () => import('@/views/Hero/HeroEdit')
const FaqsList = () => import('@/views/Faqs/FaqsList')
const FaqAdd = () => import('@/views/Faqs/FaqAdd')
const FaqEdit = () => import('@/views/Faqs/FaqEdit')
const EventsList = () => import('@/views/Events/EventsList')
const EventAdd = () => import('@/views/Events/EventAdd')
const EventEdit = () => import('@/views/Events/EventEdit')
const CategoriesList = () => import('@/views/Categories/CategoriesList')
const CategoryAdd = () => import('@/views/Categories/CategoryAdd')
const CategoryEdit = () => import('@/views/Categories/CategoryEdit')
const GalleryList = () => import('@/views/Gallery/GalleryList')
const GalleryAdd = () => import('@/views/Gallery/GalleryAdd')


Vue.use(Router)

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: `/${i18n.locale}/routes`,
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: '/:lang/routes',
          redirect: `/${i18n.locale}/routes/list`,
          name: 'Routes',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'RoutesList',
              component: RoutesList
            },
            {
              path: 'add',
              name: 'RouteAdd',
              component: RouteAdd
            },
            {
              path: 'edit',
              name: 'RouteEdit',
              component: RouteEdit
            },
          ]
        },
        {
          path: '/:lang/reservations',
          redirect: `/${i18n.t(i18n.locale)}/reservations/list`,
          name: 'Reservations',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'ReservationsList',
              component: ReservationsList
            },
            {
              path: 'add',
              name: 'ReservationAdd',
              component: ReservationAdd
            },
            {
              path: 'edit',
              name: 'ReservationEdit',
              component: ReservationEdit
            },
          ]
        },
        {
          path: '/:lang/products',
          redirect: `/${i18n.t(i18n.locale)}/products/list`,
          name: 'Products',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'ProductsList',
              component: ProductsList
            },
            {
              path: 'add',
              name: 'ProductAdd',
              component: ProductAdd
            },
            {
              path: 'edit',
              name: 'ProductEdit',
              component: ProductEdit
            },
          ]
        },
        {
          path: '/:lang/pois',
          redirect: `/${i18n.t(i18n.locale)}/pois/list`,
          name: 'Pois',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'PoisList',
              component: PoisList
            },
            {
              path: 'add',
              name: 'PoiAdd',
              component: PoiAdd
            },
            {
              path: 'edit',
              name: 'PoiEdit',
              component: PoiEdit
            },
          ]
        },
        {
          path: '/:lang/pages',
          redirect: `/${i18n.t(i18n.locale)}/pages/list`,
          name: 'Pages',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'PagesList',
              component: PagesList
            },
            {
              path: 'add',
              name: 'PageAdd',
              component: PageAdd
            },
            {
              path: 'edit/:slug',
              name: 'PageEdit',
              component: PageEdit
            },
          ]
        },
        {
          path: '/:lang/orders',
          redirect: `/${i18n.t(i18n.locale)}/orders/list`,
          name: 'Orders',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'OrdersList',
              component: OrdersList
            },
          ]
        },
        {
          path: '/:lang/news',
          redirect: `/${i18n.t(i18n.locale)}/news/list`,
          name: 'News',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'NewsList',
              component: NewsList
            },
            {
              path: 'add',
              name: 'NewsAdd',
              component: NewsAdd
            },
            {
              path: 'edit',
              name: 'NewsEdit',
              component: NewsEdit
            },
          ]
        },
        {
          path: '/:lang/hero',
          redirect: `/${i18n.t(i18n.locale)}/hero/list`,
          name: 'Hero',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'HeroList',
              component: HeroList
            },
            {
              path: 'add',
              name: 'HeroAdd',
              component: HeroAdd
            },
            {
              path: 'edit',
              name: 'HeroEdit',
              component: HeroEdit
            },
          ]
        },
        {
          path: '/:lang/faqs',
          redirect: `/${i18n.t(i18n.locale)}/faqs/list`,
          name: 'Faqs',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'FaqsList',
              component: FaqsList
            },
            {
              path: 'add',
              name: 'FaqAdd',
              component: FaqAdd
            },
            {
              path: 'edit',
              name: 'FaqEdit',
              component: FaqEdit
            },
          ]
        },
        {
          path: '/:lang/events',
          redirect: `/${i18n.t(i18n.locale)}/events/list`,
          name: 'Events',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'EventsList',
              component: EventsList
            },
            {
              path: 'add',
              name: 'EventAdd',
              component: EventAdd
            },
            {
              path: 'edit',
              name: 'EventEdit',
              component: EventEdit
            },
          ]
        },
        {
          path: '/:lang/categories',
          redirect: `/${i18n.t(i18n.locale)}/categories/list`,
          name: 'Categories',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'CategoriesList',
              component: CategoriesList
            },
            {
              path: 'add',
              name: 'CategoryAdd',
              component: CategoryAdd
            },
            {
              path: 'edit',
              name: 'CategoryEdit',
              component: CategoryEdit
            },
          ]
        },
        {
          path: '/:lang/gallery',
          redirect: `/${i18n.t(i18n.locale)}/gallery/list`,
          name: 'Gallery',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'GalleryList',
              component: GalleryList
            },
            {
              path: 'add',
              name: 'GalleryAdd',
              component: GalleryAdd
            },
          ]
        },

      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    { path: '/logout'},
    {
      path: '/404',
      name: '404',
      component: Page404
    },   
    // The reason I've separated it into 2 routes is so that you can also programmatically direct the user to the 404 route in such a case when some data you need does not resolve. 
    { path: '*', redirect: '/404' },  
    {
      path: '/500',
      name: '500',
      component: Page500
    }, 
  ]
}

